import Vue from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy, {
  interactive: false,
  placement: "bottom-end",
  arrow: false,
  followCursor: true,
  duration: 0,
  offset: "10,10",
});
Vue.component("tippy", TippyComponent);
export default {};
